<mat-dialog-content>
    <div class="popup-head">Change Password</div>
    <div>
        <div style="display: flex">
            <div>
                <div class="popup-subhead">New Password</div>
                <input type="password"  class="form-control popup-input" [(ngModel)]="password" (click)="changeHandeler()" />
            </div>
            <div>
                <div class="popup-subhead">Confirm Password</div>
                <input type="password" class="form-control popup-input" [(ngModel)]="confirmPassword" (click)="changeHandeler()"/>
            </div>
        </div>
    </div>
    <div *ngIf="notValidFalg" class="text-danger" style="text-align: center;">
      Password does not match
    </div>
    <div *ngIf="requireMiss" class="text-danger" style="text-align: center;">
      All feilds are mandatory
    </div>
    <div class="buttomPartAddResto">
        <div  class="common closeBtn" (click)="close()">
          Close
        </div>
        <div class="common submitBtn" (click)="updatePass()">
          Update
        </div>
      </div>
</mat-dialog-content>

<style>
    ::ng-deep .mat-dialog-container {
        padding: 0;

        overflow-x: hidden;
    }

    ::ng-deep .mat-dialog-content::-webkit-scrollbar {
        display: none;
    }

    .popup-head {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        color: rgba(57, 64, 70, 1);
        background-color: rgba(238, 238, 238, 1);
        width: 724px;
        height: 52px;
        display: flex;
        align-items: center;
        padding-left: 25px;
    }
    .popup-subhead {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: rgba(23, 83, 117, 1);
    padding-left: 25px;
    margin-top: 20px;
  }

  .popup-input {
    width: 322px;
    margin: 20px;
  }
  .buttomPartAddResto {
    display: flex;
    justify-content: end;
  }

  .common {
    padding: 5px 29px;
    margin: 30px 9px;
    cursor: pointer;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    border-radius: 6px;
  }

  .common:hover {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
      rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  }

  .closeBtn {
    color: rgba(57, 64, 70, 1);
    border: 2px solid rgba(57, 64, 70, 1);
  }

  .submitBtn {
    color: rgba(255, 255, 255, 1);
    background: linear-gradient(90.17deg, #2fb9e3 -97.61%, #56ab51 120.65%);
    border-radius: 6px;
  }
</style>